export default function (){
	const patterns = document.querySelectorAll('[data-name="text-bg-pattern"]');

	if ( patterns.length > 0 ) {
		patterns.forEach( pattern => {
			if ( pattern.parentNode.offsetHeight  > 500 ) {
				pattern.classList.remove('opacity-0');
			}
		});
	}
}